import { dispatchEvent } from "../../shared/events";
import salesEvents from "../../shared/salesEvents";

export const $tokenCatcher = function ($rootScope, $notifier, UserService, $timeout) {

  let tokenCatcher = {
    suspended: false
  };

  tokenCatcher.onTooMany = () => {
    salesEvents.add('catcher', 'onTooMany', { user: UserService.user });
    $timeout(() => {
      if (UserService.user.isFreeUser || UserService.user.isExpiredUser) {
        dispatchEvent('requestsExhausted');
      } else {
        $notifier.red('Too many recent searches. Try again later.');
      }
    })
  }

  tokenCatcher.onPaymentRequired = () => {
    salesEvents.add('catcher', 'onPaymentRequired', { user: UserService.user });
    $timeout(() => {
      if (UserService.user.isFreeUser || UserService.user.isExpiredUser) {
        dispatchEvent('requestsExhausted');
      } else {
        dispatchEvent('triedToExceedDailySearches');
      }
    });
  }

  $rootScope.$on('token::429', tokenCatcher.onTooMany);
  $rootScope.$on('token::402', tokenCatcher.onPaymentRequired);

  $rootScope.$on('token::403', function () {
    tokenCatcher.suspended = true;
  });

  return tokenCatcher;

};

$tokenCatcher.$inject = ['$rootScope', '$notifier', 'UserService', '$timeout'];
